/* eslint-disable react/jsx-key */
import React, {ChangeEvent, PropsWithChildren, useMemo, useState} from 'react';

// Components
import InputSearch from 'Components/flowChart/components/InputSearch';

// styled
import {Wrapper, WrapperContent} from 'Components/flowChart/components/OptionPopup/index.style';

// Assets
import Collapse from 'Components/flowChart/components/Collapse';

// Types
import {ICallback, IData} from 'Components/flowChart/components/OptionPopup/types';
import {checkViolationByRules} from 'Components/flowChart/utils';
import {INode, RulesObj} from 'Components/flowChart/types';

interface IOptionPopup {
	nodeId: string;
	isOpen: boolean;
	tableNodes: IData;
	dataNodes: INode[];
	callback: ICallback;
	rules: RulesObj;
	onError?: (error: Error, detail: Record<string, unknown>) => void;
}

const OptionPopup = React.forwardRef<HTMLDivElement, PropsWithChildren<IOptionPopup>>((props, ref) => {
	const {nodeId, isOpen, tableNodes, dataNodes, callback, rules} = props;

	const [search, setSearch] = useState('');

	const dataItems: IData = useMemo(() => {
		const checkViolateFn = checkViolationByRules({
			rules,
			data: dataNodes,
			nodeBefore: {id: nodeId}
		});

		const newData = {
			header: tableNodes.header.map((group) => group.map((item) => ({...item, disabled: checkViolateFn(item)}))),

			body: tableNodes.body.map((item) => ({...item, disabled: checkViolateFn(item)}))
		};

		if (search?.length) {
			const header = newData.header.map((group) =>
				group.filter((item) => item.label.toLowerCase().includes(search.toLowerCase()))
			);

			const body = newData.body.filter((item) => item.label.toLowerCase().includes(search.toLowerCase()));

			return {header, body};
		}

		return newData;
	}, [search, tableNodes, rules]);

	if (!isOpen) {
		return null;
	}

	const handleChangeSearch = (event: ChangeEvent<HTMLInputElement>) => {
		setSearch(event.target.value);
	};

	const renderActionNodes = () => {
		return dataItems.header.map((group, index) => {
			if (!group?.length) {
				return null;
			}

			const header = group.length > 0 ? (index === 0 ? 'Trigger' : 'Action') : 'Action';

			return <Collapse key={group?.[0]?.key} header={header} items={group} onChange={callback} />;
		});
	};

	return (
		<Wrapper ref={ref}>
			<InputSearch value={search} onChange={handleChangeSearch} />
			<WrapperContent>
				{renderActionNodes()}
				{dataItems.body?.length ? (
					<Collapse header="Destination" items={dataItems.body} onChange={callback} />
				) : null}
			</WrapperContent>
		</Wrapper>
	);
});

export default OptionPopup;
